import { render, staticRenderFns } from "./pageSetting.vue?vue&type=template&id=79c1fddf&scoped=true"
import script from "./pageSetting.vue?vue&type=script&lang=js"
export * from "./pageSetting.vue?vue&type=script&lang=js"
import style0 from "./pageSetting.vue?vue&type=style&index=0&id=79c1fddf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c1fddf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c1fddf')) {
      api.createRecord('79c1fddf', component.options)
    } else {
      api.reload('79c1fddf', component.options)
    }
    module.hot.accept("./pageSetting.vue?vue&type=template&id=79c1fddf&scoped=true", function () {
      api.rerender('79c1fddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/pageSetting/pageSetting.vue"
export default component.exports